module.exports = __webpack_public_path__ + "img/convert-to-case-active.ebf9340e.svg";